import React, { useState, useEffect } from 'react'
import { Tooltip } from 'react-tooltip'

const DynamicCard = (props) => {
    const {
        data = [],
        handleAccessClick = [],
        onSearch,
        onPageChange,
        totalRows, // Total de filas que pasas como prop
        entriesPerPage = 5 // Registros por página (valor por defecto)
    } = props

    const [pagination, setPagination] = useState({
        currentPage: 1,
        entriesPerPage, // Inicializa con el valor de entriesPerPage
    })

    const [searchTerm, setSearchTerm] = useState(""); // Estado para el término de búsqueda

    useEffect(() => {
        // Resetear la página actual si cambia el total de filas
        setPagination((prev) => ({
            ...prev,
            currentPage: 1,
        }))
    }, [totalRows])

    const totalPages = Math.ceil(totalRows / pagination.entriesPerPage)

    const goToPage = (page) => {
        setPagination((prev) => ({
            ...prev,
            currentPage: page,
        }))
        if (onPageChange) {
            onPageChange(page, pagination.entriesPerPage) // Enviar también el tamaño de página
        }
    }

    const prev = () => {
        if (pagination.currentPage > 1) {
            goToPage(pagination.currentPage - 1)
        }
    }

    const next = () => {
        if (pagination.currentPage < totalPages) {
            goToPage(pagination.currentPage + 1)
        }
    }

    const handleInputChange = (e) => {
        setSearchTerm(e)
        if (e === "") {
            onSearch('')
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            onSearch(searchTerm);
        }
    }

    const startIndex = (pagination.currentPage - 1) * pagination.entriesPerPage

    return (
        <div className="card">
            <div className="card-body">

                <div className="d-flex justify-content-between align-items-center mb-3">

                    <select
                        className="form-control col-md-1"
                        aria-label="Rows per page"
                        value={pagination.entriesPerPage} // Mantener el valor en el estado
                        onChange={(e) => {
                            const newEntriesPerPage = Number(e.target.value)
                            setPagination((prev) => ({
                                ...prev,
                                entriesPerPage: newEntriesPerPage,
                                // NO reiniciar a la primera página
                                currentPage: Math.min(prev.currentPage, Math.ceil(totalRows / newEntriesPerPage)), // Mantener la página actual si es válida
                            }))
                            if (onPageChange) {
                                onPageChange(pagination.currentPage, newEntriesPerPage) // Llamar a la función de cambio de página
                            }
                        }}
                    >
                        {[5, 10, 15, 20].map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                    <div className="input-group col-md-6">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar por nombre"
                            value={searchTerm}
                            onChange={(e) => handleInputChange(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                        <button className="btn btn-primary" onClick={(e) => onSearch(searchTerm)}>
                            <i className="fas fa-search"></i>
                        </button>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            {data.map((tablero) => (
                                <div className="col-12 col-md-6 col-lg-4 mb-4" key={tablero.id}>
                                    <div className="dashboard-cards">
                                        <div className="card-item">
                                            <div className="card-content-container">
                                                <div className="card-icon-yellow yellow-icon">
                                                    <span><i className="fas fa-chart-line"></i></span>
                                                </div>
                                                <div className="card-content">
                                                    <h3
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            maxWidth: '100%',
                                                        }}
                                                        data-tooltip-id={`name-${tablero.id}`}
                                                        data-tooltip-content={tablero.Nombre}
                                                    >
                                                        {tablero.Nombre.length > 15
                                                            ? `${tablero.Nombre.substring(0, 15)}...`
                                                            : tablero.Nombre
                                                        }
                                                    </h3>
                                                    <Tooltip
                                                        id={`name-${tablero.id}`}
                                                        place="top"
                                                        effect="solid"
                                                        style={{
                                                            backgroundColor: '#b3e5fc',  // Fondo celeste cálido
                                                            color: '#000',               // Color del texto
                                                            borderRadius: '12px',        // Bordes redondeados
                                                            padding: '10px',             // Espaciado interno
                                                            maxWidth: '200px',           // Limitar el ancho máximo del tooltip
                                                            whiteSpace: 'normal',        // Permitir saltos de línea
                                                            wordWrap: 'break-word',      // Ajustar texto largo
                                                            textAlign: 'center',         // Centrar el texto
                                                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'  // Sombra para resaltarlo
                                                        }}
                                                    />

                                                    {/* Acortar texto y mostrar tooltip */}
                                                    <p
                                                        className="analytic-text"
                                                        data-tooltip-id={`desc-${tablero.id}`}
                                                        data-tooltip-content={tablero.Descripcion}
                                                    >
                                                        {tablero.Descripcion.length > 10
                                                            ? `${tablero.Descripcion.substring(0, 10)}...`
                                                            : tablero.Descripcion
                                                        }
                                                    </p>
                                                    <Tooltip
                                                        id={`desc-${tablero.id}`}
                                                        place="top"
                                                        effect="solid"
                                                        style={{
                                                            backgroundColor: '#b3e5fc',  // Fondo celeste cálido
                                                            color: '#000',               // Color del texto
                                                            borderRadius: '12px',        // Bordes redondeados
                                                            padding: '10px',             // Espaciado interno
                                                            maxWidth: '200px',           // Limitar el ancho máximo del tooltip
                                                            whiteSpace: 'normal',        // Permitir saltos de línea
                                                            wordWrap: 'break-word',      // Ajustar texto largo
                                                            textAlign: 'center',         // Centrar el texto
                                                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'  // Sombra para resaltarlo
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                            <button
                                                className="access-btn"
                                                onClick={() => handleAccessClick(tablero.id)}
                                            >
                                                Acceder
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>


                <div className="d-flex justify-content-between align-items-center">
                    <span>
                        Mostrando {startIndex + 1} a {Math.min(startIndex + pagination.entriesPerPage, totalRows)} de {totalRows} registros
                    </span>
                    <div className="ms-auto">
                        <button className="btn btn-light" disabled={pagination.currentPage === 1} onClick={prev}>
                            Anterior
                        </button>
                        {/* Paginación con puntos suspensivos */}
                        {totalPages <= 10 ? (
                            Array.from({ length: totalPages }, (_, index) => (
                                <button
                                    key={index}
                                    className={`btn ${index + 1 === pagination.currentPage ? 'btn-primary' : 'btn-light'}`}
                                    onClick={() => goToPage(index + 1)}
                                >
                                    {index + 1}
                                </button>
                            ))
                        ) : (
                            <>
                                {pagination.currentPage > 5 && (
                                    <>
                                        <button className="btn btn-light" onClick={() => goToPage(1)}>1</button>
                                        <span className="btn btn-light">...</span>
                                    </>
                                )}
                                {Array.from({ length: 5 }, (_, index) => {
                                    const page = pagination.currentPage - 2 + index
                                    return page > 0 && page <= totalPages ? (
                                        <button
                                            key={page}
                                            className={`btn ${page === pagination.currentPage ? 'btn-primary' : 'btn-light'}`}
                                            onClick={() => goToPage(page)}
                                        >
                                            {page}
                                        </button>
                                    ) : null
                                })}
                                {pagination.currentPage < totalPages - 4 && (
                                    <>
                                        <span className="btn btn-light">...</span>
                                        <button className="btn btn-light" onClick={() => goToPage(totalPages)}>{totalPages}</button>
                                    </>
                                )}
                            </>
                        )}
                        <button className="btn btn-light" disabled={pagination.currentPage === totalPages} onClick={next}>
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DynamicCard
